import { defineStore } from "pinia";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    cid: null,
    codeVerifier: null,
    bid: null,
    user: {},
  }),

  getters: {
    isAuthenticated(state) {
      return typeof state.user === "object" && !!state.user.identityId;
    },
    isBffAuthenticated(state) {
      return !!state.cid && !!state.codeVerifier;
    },
    getCid(state) {
      console.log("getCid - state:", state.cid);
      return state.cid;
    },
    getBid(state) {
      console.log("getBid - state:", state.bid);
      return state.bid;
    },
    getCodeVerifier(state) {
      console.log("GET codeVerifier", state.codeVerifier);
      return state.codeVerifier;
    },
    userName(state) {
      return state.user.name;
    },
    getUser(state) {
      return state.user;
    },
  },

  actions: {
    setCid(uuidv4) {
      this.cid = uuidv4;
    },
    setBid(bid) {
      console.log("SET bid", bid);
      this.bid = bid;
    },
    setCodeVerifier(base64String) {
      console.log("SET codeVerifier", base64String);
      this.codeVerifier = base64String;
    },
    setUser(userObj) {
      this.user = userObj;
    },
    delUser() {
      this.user = {};
    },
    reset() {
      this.cid = null;
      this.codeVerifier = null;
      this.bid = null;
      this.user = {};
    },
  },
});
